<template>
  <section class="page-grid py-4 md:py-12">
    <h2
      class="heading-sm md:heading-md col-span-12 text-center"
      v-text="`Choose Your Course Format`"
    />
    <div class="col-span-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
      <div
        v-for="(courseFormat, index) in filteredCourseFormats"
        :key="`courseFormat-${index}`"
        class="flex flex-col gap-y-3 rounded-xl bg-gray-100 p-6"
      >
        <div class="flex justify-between gap-2">
          <h3
            class="heading-sm"
            v-text="courseFormat.title"
          />
          <p
            class="heading-sm text-right"
            v-text="courseFormat.price"
          />
        </div>

        <div class="mb-auto border-t border-gray-300 pt-4">
          <h4
            class="wc-overline"
            v-text="courseFormat.headline"
          />
          <div
            class="prose"
            v-html="courseFormat.description"
          />
        </div>

        <a
          :href="courseFormat.url"
          class="btn btn--primary"
        >
          <span v-text="'View Course Details'" />
          <span
            class="sr-only"
            v-text="`for ${courseFormat.title} Courses`"
          />
        </a>
      </div>
    </div>
    <!--<div
      v-if="courseFormats.length > 3"
      class="col-span-12"
    >
      <button
        class="btn btn--outline mx-auto"
        type="button"
        @click="showingAll = !showingAll"
        v-text="showingAll ? `view less course formats` : `view all course formats`"
      />
    </div>-->
  </section>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

defineOptions({
  name: 'AppCourseFormat',
})

const props = defineProps<{
  courseFormats: {title: string, price:string, headline:string, description:string, url:string}[]
}>()

const showingAll = ref(false)

const filteredCourseFormats = computed(() => {
  return showingAll.value ? props.courseFormats : props.courseFormats.slice(0, 6)
})
</script>
